import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"
import { Container } from "reactstrap";
import WelcomeComp from "./WelcomeComp";
import { Row, Col } from "reactstrap"

import './dashboard.scss'


//i18n
import { withTranslation } from "react-i18next";

// import { FaExpand, FaTimes } from 'react-icons/fa';
const Plans = props => {
  //meta title
  document.title = "Plans | ICE - Student Portal";

  
  return (
    <React.Fragment>
      <div className="page-content" style={{ position: 'relative' }}>

    
            <WelcomeComp />
  
      </div>
    </React.Fragment>
  );
};

Plans.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Plans);
